module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changeTitle":"Change Password","oldText":"Old Password","newText":"New Password","secNewText":"Retype New Password","changeButton":"change","forgetText":"Forget the old password"},"zn":{"changeTitle":"修改密码","oldText":"旧密码","newText":"新密码","secNewText":"重复新密码","changeButton":"确定","forgetText":"忘记旧密码"}}')
  delete Component.options._Ctor
}
